/* eslint-disable react/no-danger */
import React, { useState, useEffect, useRef } from 'react';

import cx from 'classnames';

const StopAndThink = ({ additionalClassNames, onChangeHandler, shouldDisplayInputField = false, text }) => {
  const stopAndThinkClassNames = cx('c-stop-think', additionalClassNames);

  const [stopAndThinkValue, setStopAndThinkValue] = useState('');

  const textareaRef = useRef(null);

  const handleChange = (value) => {
    onChangeHandler?.(value);
    setStopAndThinkValue(value);
  };

  useEffect(() => {
    if (!textareaRef.current) {
      return;
    }

    onChangeHandler?.(textareaRef.current.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textareaRef]);

  useEffect(() => {
    setStopAndThinkValue('');
  }, [text]);

  return (
    <div className={stopAndThinkClassNames}>
      <h3>Stop and think</h3>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      {shouldDisplayInputField ? (
        <textarea
          ref={textareaRef}
          className="c-stop-think__textarea"
          id="stop-think"
          title="Stop and think"
          value={stopAndThinkValue}
          onChange={({ target }) => handleChange(target.value)}
        />
      ) : null}
    </div>
  );
};

export { StopAndThink };
